import h from "./index4.js";
import { resolveComponent as t, openBlock as o, createElementBlock as c, normalizeClass as l, createBlock as n, createElementVNode as i, withDirectives as L, createVNode as a, vShow as C, createCommentVNode as s } from "vue";
import "./index5.js";
import b from "../../../../_virtual/index.js";
const N = { class: "footer-row" }, v = { class: "footer-wrapper" }, w = { class: "footer-left" }, F = { class: "footer-right" }, D = { class: "logo-country-col" };
function Q(e, I, P, T, V, $) {
  const S = t("FooterSkeleton"), u = t("FooterLogo"), m = t("CSRPhoneNumber"), y = t("SocialLinks"), r = t("TrustLogos"), p = t("Links"), d = t("country-selector"), g = t("Disclaimer"), f = t("FooterMobile"), k = t("policy-dialog");
  return o(), c("footer", {
    class: l([
      "footer",
      e.isSimpleStyle ? "simple" : "",
      e.isSelectionStyle ? "selection-page" : "",
      e.isNoneStyle ? "none" : ""
    ])
  }, [
    e.notLoaded || !e.areTranslationsLoaded ? (o(), n(S, { key: 0 })) : (o(), c("div", {
      key: 1,
      class: l([
        "footer-container desktop",
        e.isSelectionStyle ? "selection-page" : ""
      ])
    }, [
      i("div", N, [
        i("div", v, [
          i("div", w, [
            L(a(u, {
              onClickCapture: e.trackLogoClick,
              config: e.config
            }, null, 8, ["onClickCapture", "config"]), [
              [C, e.isNormalStyle && !e.isSelectionStyle]
            ]),
            (e.isNormalStyle || e.isSelectionStyle) && e.showPhoneInfo ? (o(), n(m, {
              key: 0,
              phoneNumber: e.csrInfo.phoneNumber,
              phoneHours: e.csrInfo.phoneHours
            }, null, 8, ["phoneNumber", "phoneHours"])) : s("", !0),
            e.isNormalStyle && !e.isSelectionStyle && e.showSocialLinks ? (o(), n(y, { key: 1 })) : s("", !0),
            e.showLeftTrustLogo && !e.isSelectionStyle ? (o(), n(r, {
              key: 2,
              class: l(e.trustLogosClass),
              isSimpleLogo: e.config.sitebrand === "LawDepot"
            }, null, 8, ["class", "isSimpleLogo"])) : s("", !0)
          ]),
          i("div", F, [
            e.isNormalStyle && !e.isSelectionStyle ? (o(), n(p, {
              key: 0,
              links: e.footerLinks
            }, null, 8, ["links"])) : s("", !0),
            i("div", D, [
              e.isNormalStyle && !e.isSelectionStyle ? (o(), n(d, {
                key: 0,
                currentCountry: e.countrySelectorSettings.currentCountry,
                countries: e.countrySelectorSettings.countries,
                majorCountries: e.countrySelectorSettings.majorCountries,
                variant: e.countryVariant.NamedFlagWithExpansionOnClick
              }, null, 8, ["currentCountry", "countries", "majorCountries", "variant"])) : s("", !0),
              !e.isSimpleStyle || e.isSelectionStyle ? (o(), n(r, {
                key: 1,
                isSelectionStyle: e.isSelectionStyle
              }, null, 8, ["isSelectionStyle"])) : s("", !0)
            ])
          ])
        ])
      ]),
      e.shouldShowDisclaimer ? (o(), n(g, {
        key: 0,
        settings: e.disclaimerSettings,
        class: "disclaimer-container",
        isSimpleStyle: e.isSimpleStyle,
        isQuebec: e.isQuebec
      }, null, 8, ["settings", "isSimpleStyle", "isQuebec"])) : s("", !0)
    ], 2)),
    a(f, {
      countrySelectorSettings: e.countrySelectorSettings,
      disclaimerSettings: e.disclaimerSettings,
      footerStyle: e.footerStyle,
      notLoaded: e.notLoaded,
      class: "footer-mobile",
      isQuebec: e.isQuebec
    }, null, 8, ["countrySelectorSettings", "disclaimerSettings", "footerStyle", "notLoaded", "isQuebec"]),
    e.showPolicyDialog ? (o(), n(k, {
      key: 2,
      disclaimerSettings: e.disclaimerSettings
    }, null, 8, ["disclaimerSettings"])) : s("", !0)
  ], 2);
}
const M = /* @__PURE__ */ b(h, [["render", Q], ["__scopeId", "data-v-6b801409"]]);
export {
  M as default
};
//# sourceMappingURL=index3.js.map
